import React from 'react';

import {contactListColumnIds} from '../../../../../util/uiconstants';

import DashboardCheck from '../../DashboardCheck';

const ContactListColumn = ({item}) => <DashboardCheck condition={item.hasAccess} />;

export const config = (labels) => ({
	id: contactListColumnIds.contactList,
	label: labels.columnContactList,
	propName: 'contList',
	width: 'var(--px-200)',
	sortBy: [{propName: 'contactList', sortByField: 'hasAccess'}, 'name', 'lastName'],
	customCell: (item) => {
		const props = {item};
		return <ContactListColumn {...props} />;
	}
});
